// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"084ce8aa","732":"a5564321","977":"d55784e0"}[chunkId] + ".chunk.js";
};